import { FilterValues } from "../../../data-model/filterValues";
import { EventForAuditTrail } from "../../../data-model/viewAllEvents";
import { processFilterData } from "../../../utils/queryConstraint";

export const generateFilteredDataForAllEvents = (
  data: EventForAuditTrail[],
  filters: FilterValues[],
) => {
  let filteredData = data;
  const filtersAfterProcessing = processFilterData(filters);
  const filterKeys = Object.keys(filtersAfterProcessing);
  for (const key of filterKeys) {
    if (key === "event_type") {
      filteredData = filteredData.filter((event) =>
        filtersAfterProcessing[key].includes(event?.event_type ?? ""),
      );
    }
  }

  return filteredData;
};
